<template>
<b-card no-body>
  <b-card-header>
    <b-card-title title-tag="h5">SEO Settings</b-card-title>
  </b-card-header>
  <validation-observer v-slot="{ handleSubmit }" ref="VFormSEO">
    <b-form @submit.prevent="handleSubmit(submitSEO)">
      <b-card-body>
        <b-row>
          <b-col md=8>
            <b-form-group label-for="homeMetaTitle">
              <template #label>
                Meta Title
                <b-badge variant="info" pill class="help-badge" v-b-tooltip.hover.right="'Isi kolom ini untuk memudahkan mesin pencari memahami judul dari halaman website. Tips: Maksimal karakter yang disarankan untuk Meta Title adalah 60 karakter.'">
                  <i class="fas fa-question"></i>
                </b-badge>
              </template>
              <b-form-input id="homeMetaTitle" placeholder="Meta Title" v-model="row.asp_title" />
              <VValidate name="Meta Title" v-model="row.asp_title" :rules="{...validation.asp_title, regex:/^[^\s]+(\s+[^\s]+)*$/}" />
            </b-form-group>
          </b-col>
          <b-col md=8>
            <b-form-group label-for="homeMetaDesc">
              <template #label>
                Meta Description
                <b-badge variant="info" pill class="help-badge" v-b-tooltip.hover.right="'Isi kolom ini sebagai deskripsi singkat dari isi halaman website. Tips: Maksimal karakter yang disarankan untuk Meta Description adalah 120-155 karakter.'">
                  <i class="fas fa-question"></i>
                </b-badge>
              </template>
              <b-form-textarea rows="5" id="homeMetaDesc" placeholder="Meta Description" v-model="row.asp_description" />
              <VValidate name="Meta Description" v-model="row.asp_description" :rules="{...validation.asp_description, regex:/^[^\s]+(\s+[^\s]+)*$/}" />
            </b-form-group>
          </b-col>
          <b-col md=8>
            <b-form-group label-for="homeMetaTags">
              <template #label>
                Meta Keywords
                <b-badge variant="info" pill class="help-badge" v-b-tooltip.hover.right="'Isi kolom ini untuk memudahkan mesin pencari memahami topik halaman website. Gunakan keyword yang relevan dan user friendly, maksimal 10 keyword.'">
                  <i class="fas fa-question"></i>
                </b-badge>
              </template>
              <b-form-tags id="homeMetaTags" v-model="row.asp_keywords" placeholder="Type and press enter ..." remove-on-delete :tag-validator="parent.validatorTags" tag-variant="primary" tag-class="text-white" />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
      <b-card-footer>
        <div class="text-right">
          <b-button class="btn-rounded" type="submit" variant="primary">Save Changes</b-button>
        </div>
      </b-card-footer>
    </b-form>
  </validation-observer>
</b-card>
</template>

<script>
import Gen from '@/libs/Gen.js'

export default {
  data() {
    return {
      row: {},
      validation: {}
    }
  },
  computed: {
    parent() {
      return this.$parent.$parent.$parent
    }
  },
  mounted() {
    this.apiGet()
  },
  methods: {
    apiGet() {
      Gen.apiRest('/get/' + this.parent.modulePage + '/seo', {}, 'GET').then(res => {
        this.row = res.data.row
        this.validation = res.data.validation
      })
    },
    submitSEO() {
      this.$refs.VFormSEO.validate().then(success => {
        if (!success) return

        this.parent.loadingOverlay = true

        Gen.apiRest('/do/' + this.parent.modulePage, {
          data: {
            type: 'updateSeo',
            ...this.row
          }
        }).then(res => {
          if (res) {
            this.parent.loadingOverlay = false
            this.$swal({
              title: res.data.message,
              icon: 'success',
            }).then(() => {
              this.apiGet()
            })
          }
        }).catch(err => {
          this.parent.loadingOverlay = false
          this.$swal({
            title: err.response.data.message,
            icon: 'error'
          })
        })
      })

    },
  }
}
</script>
